import { pushHistory, replaceHistory } from '@jetshop/core/components/Filters/utils/updateHistory';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import report from '@jetshop/core/errorReporting';
import qs from 'qs';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { withCookies } from 'react-cookie';
import { useHistory, useLocation } from 'react-router';
const updateHistory = ({ history, location }, newPage, queryParam, options) => {
    const currentSearch = qs.parse(typeof window === 'undefined' ? location.search : window.location.search, { ignoreQueryPrefix: true });
    const search = Object.assign(Object.assign({}, currentSearch), { [queryParam]: newPage });
    if (options && options.replace) {
        replaceHistory({
            history,
            pathname: location.pathname,
            hash: location.hash,
            search,
            resetPage: newPage === 1,
            routeType: 'paginationChange'
        });
    }
    else {
        pushHistory({
            history,
            pathname: location.pathname,
            hash: location.hash,
            search,
            resetPage: newPage === 1,
            routeType: 'paginationChange'
        });
    }
    return true;
};
const getPageFromSearch = (location, queryParam) => {
    let page = null;
    // Get the page from the search parameter in the URL
    if (location.search) {
        page = parseInt(qs.parse(location.search, { ignoreQueryPrefix: true })[queryParam], 10);
    }
    return page;
};
const calculateOffset = (page, perPage) => {
    if (page > 0 && page < 1000) {
        return (page - 1) * perPage;
    }
    else {
        return 0;
    }
};
const PaginationProvider = ({ cookies, defaultProductsPerPage = 16, children, queryParam = 'page', errorReportingEnabled = true }) => {
    const history = useHistory();
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState(getPageFromSearch(location, queryParam) || 1);
    useEffect(() => {
        const page = getPageFromSearch(location, queryParam);
        if (page) {
            setCurrentPage(page);
        }
        if (!page && currentPage !== 1) {
            setCurrentPage(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
    const goToPage = useCallback((page, options) => {
        setCurrentPage(page);
        updateHistory({ location, history }, page, queryParam, options);
    }, [location, history, queryParam]);
    const setProductsPerPage = useCallback((perPage) => {
        cookies.set('perPage', `${perPage}`);
        setCurrentPage(1);
    }, [cookies]);
    const cookieProductsPerPage = parseInt(cookies.get('perPage'), 10);
    const perPage = cookieProductsPerPage || defaultProductsPerPage;
    if (errorReportingEnabled && currentPage >= 1000) {
        report(new Error('Page number is too nigh'), {
            currentPage,
            perPage,
            location,
            history
        });
    }
    const value = useMemo(() => ({
        currentPage,
        offset: calculateOffset(currentPage, perPage),
        perPage,
        goToPage,
        setProductsPerPage,
        queryParam
    }), [currentPage, perPage, goToPage, setProductsPerPage, queryParam]);
    return (React.createElement(PaginationContext.Provider, { value: value }, children));
};
export function usePagination() {
    return useContext(PaginationContext);
}
export default withCookies(PaginationProvider);
//# sourceMappingURL=PaginationProvider.js.map